module.exports = __webpack_public_path__ + "img/potion_img_07.8bb8d2d2.png";